import { setAlert } from '../../alert';
import { getConfig, getFormDataConfig } from '../constants/00-base-constants';
import {
    API_POST_RENEWABLE_ENERGY_DATA,
    API_GET_RENEWABLE_ENERGY_DATA,
    API_GET_RENEWABLE_ENERGY_DATA_TOTALS
} from '../constants/02-indirect-ghg-emissions-from-imported-energy';
import {
    POST_RENEWABLE_ENERGY_DATA_SUCCESS,
    POST_RENEWABLE_ENERGY_DATA_FAIL,
    GET_RENEWABLE_ENERGY_DATA_SUCCESS,
    GET_RENEWABLE_ENERGY_DATA_FAIL,
    GET_RENEWABLE_ENERGY_DATA_TOTALS_SUCCESS,
    GET_RENEWABLE_ENERGY_DATA_TOTALS_FAIL
} from '../types/02-indirect-ghg-emissions-from-imported-energy-types';
import api from '../../../util/api';

export const postRenewableEnergyData = (formData, year, company, group, facility, month) => async dispatch => {
    try {
        const { data } = await api().post(
            process.env.REACT_APP_API_URL + API_POST_RENEWABLE_ENERGY_DATA + `/${year}/${company}/${group}/${facility}/${month}`,
            formData,
            getFormDataConfig()
        );
        dispatch({
            type: POST_RENEWABLE_ENERGY_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: POST_RENEWABLE_ENERGY_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRenewableEnergyData = (year, facility, rowsPerPage, currentPage, month) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_RENEWABLE_ENERGY_DATA + `/${year}/${facility}/${rowsPerPage}/${currentPage}/${month}`,
            getConfig()
        );
        dispatch({
            type: GET_RENEWABLE_ENERGY_DATA_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_RENEWABLE_ENERGY_DATA_FAIL,
            payload: err.response.data.detail,
        });
    }
};

export const getRenewableEnergyDataTotals = (year, facility) => async dispatch => {
    try {
        const { data } = await api().get(
            process.env.REACT_APP_API_URL + API_GET_RENEWABLE_ENERGY_DATA_TOTALS + `/${year}/${facility}`,
            getConfig()
        );
        dispatch({
            type: GET_RENEWABLE_ENERGY_DATA_TOTALS_SUCCESS,
            payload: data,
        });
        dispatch(setAlert(data.detail, 'success'));
    } catch (err) {
        dispatch(setAlert(err.response.data.detail, 'error'));
        dispatch({
            type: GET_RENEWABLE_ENERGY_DATA_TOTALS_FAIL,
            payload: err.response.data.detail,
        });
    }
};
